import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-shipment-order-creator',
  templateUrl: './pces-client-creator.component.html',
  styleUrls: ['./pces-client-creator.component.scss']
})
export class PCESClientCreatorComponent implements OnInit {

  step = 1
  totalSteps = 3

  // initialize forms for the wizard
  contactForm!: FormGroup
  bankingInfoForm!: FormGroup
  addressForm!: FormGroup

 
  // boolean to display the wizard after the API has completed retrieving data
  showContent: boolean = true

  constructor(private http: HttpClient, private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private dialog: MatDialog) {
  }

  // load shipment details data on startup (modal opened)
  ngOnInit() {
    this.checkFormReady()
  }

  // function to prepare form data upon GET API finishing retrieving the shipment details
  private checkFormReady(): void {
    this.contactForm = this.formBuilder.group({
      clientname: [''],
      factoringfor: [''],
      clientnumber: [''],
      clientshortname: [''],
      cliententrydescription: [''],
      groupname: [''],      
      clienttransactioncode: [''],      
    })

    this.bankingInfoForm = this.formBuilder.group({
      clientbankno: [''],
      clientbranchno: [''],
      clientabaroutingno: [''],
      clientaccountno: [''],
      cliententrydescription: [''],
      clientcurrency: [''],      
    })    

    this.addressForm = this.formBuilder.group({
      clientaddress: [''],
      client_locality: [''],
      client_region: [''],
      client_postal_code: [''],
      client_country: [''],
    })        
  }

  // Proceed to the next step in the form
  nextStep() {
    if (this.step < this.totalSteps) {
      this.step++;
    }
  }

  // Move back to the previous step in the form
  prevStep() {
    if (this.step > 1) {
      this.step--;
    }
  }
  isLoading: boolean = false;
  submit() {
    this.isLoading = true;
    const formData = this.contactForm.value;
    formData.bankingInfoForm = this.bankingInfoForm.value;
    formData.addressForm = this.addressForm.value;

    let url = `/api/pces_lists/pces_client_details.php?command=CLIENT_INFO_CREATE`;

    this.http.post<any>(url, formData)
      .subscribe(response => {
        if (response) {
          setTimeout(() => {
            this.isLoading = false;
            this.contactForm.reset();
            this.bankingInfoForm.reset();
            this.addressForm.reset();
            this.dialog.closeAll();
            this.router.navigate(['/pces_client_lists']);
          }, 1500);
          console.log('Post Response: ', response);
        }
      })
      
      console.log('Client Info Create', formData);

  }

  // Change step to the step relative to the icon on the progress bar clicked on
  changeStep(newStep: number) {
    this.step = newStep;
  }

}
